import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=2b1e4141&scoped=true"
import script from "./CountryList.vue?vue&type=script&lang=js"
export * from "./CountryList.vue?vue&type=script&lang=js"
import style0 from "./CountryList.vue?vue&type=style&index=0&id=2b1e4141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e4141",
  null
  
)

export default component.exports